import { Center, Loader, Text, Stack } from '@mantine/core';

export const LoadingSpinner = ({ message = 'Caricamento...' }) => {
  return (
    <Center h="100vh">
      <Stack align="center" gap="md">
        <Loader size="lg" />
        <Text c="dimmed">{message}</Text>
      </Stack>
    </Center>
  );
};
